module.exports = __webpack_public_path__ + "rosacea_7_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/rosacea_7_before_tn.jpg
// module id = 1458
// module chunks = 0